'use strict';

var	util = require('../util');
var page = require('../page');
var SiteConstants = require('../../../../bc_sheplersbootbarn_core/cartridge/js/SiteConstants');

function initializeEvents(){
};

exports.init = function () {
    initializeEvents();    
};
